import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { fetchCmsCollection } from '../cms';

export default function ServicesPage() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    fetchCmsCollection('services').then(data => setServices(data));
  }, []);

  const sortedServices = [...services].sort((a, b) => {
    if (a.service_slug === 'staaltag') return -1;
    if (b.service_slug === 'staaltag') return 1;
    return 0;
  });

  return (
    <div className="bg-[#ffffff]">
      <Helmet>
        <title>Vi tilbyder · Ydelser - T.H Byg</title>
        <meta name="description" content="Oversigt over tømrer- og tagarbejde hos T.H Byg v/ Jacob Hartvig Hansen. Ståltag, tagrenovering, vinduer & døre, tilbygning, totalrenovering." />
      </Helmet>

      {/* Hero */}
      <section className="bg-[#11161a] text-white py-16 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-8">
          <div className="max-w-3xl">
            <span className="text-xs font-black uppercase tracking-widest text-[#d92323]">
              Professionelt Tømrerarbejde
            </span>
            <h1 className="text-3xl sm:text-5xl font-black text-white mt-2 tracking-tight">
              Vi tilbyder
            </h1>
            <p className="mt-4 text-slate-300 text-base sm:text-lg leading-relaxed">
              T.H Byg v/ Jacob Hartvig Hansen udfører alt fra specialiserede ståltage til døre, vinduer, tilbygninger og totalrenovering i Vejle, Horsens og Hedensted.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 sm:py-24 bg-[#f4f5f7]">
        <div className="mx-auto max-w-7xl px-4 sm:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {sortedServices.map((service, idx) => {
              const isSteel = service.service_slug === 'staaltag';
              const targetUrl = isSteel ? '/staaltag' : `/ydelser/${service.service_slug}`;
              return (
                <Link
                  key={service.id || idx}
                  to={targetUrl}
                  className={`group relative flex flex-col rounded-none bg-white overflow-hidden transition-all duration-300 shadow-md hover:shadow-2xl ${
                    isSteel ? 'border-2 border-[#d92323] ring-4 ring-[#d92323]/10' : 'border border-slate-200'
                  }`}
                >
                  {isSteel && (
                    <div className="absolute top-4 right-4 z-20 rounded-none bg-[#d92323] px-3 py-1 text-[11px] font-black uppercase text-white shadow-lg">
                      ★ Vores Speciale
                    </div>
                  )}

                  <div className="relative h-60 overflow-hidden bg-slate-900 rounded-none">
                    <img
                      src={service.image && service.image[0] ? service.image[0] : "https://assets.auxodev.dk/assets/4aae8b48-1e4d-42c2-9336-5940e0b091a6/th-byg-16-scaled.jpg"}
                      alt={service.title}
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110 rounded-none"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-950/80 via-transparent to-transparent" />
                    
                    <div className="absolute bottom-4 left-4 right-4">
                      <h2 className="text-xl font-black text-white drop-shadow">
                        {service.title}
                      </h2>
                    </div>
                  </div>

                  <div className="p-6 flex flex-col flex-1 justify-between space-y-4">
                    <p className="text-sm text-slate-600 leading-relaxed">
                      {service.summary}
                    </p>

                    <div
                      className={`inline-flex items-center gap-2 text-sm font-bold transition-colors ${
                        isSteel ? 'text-[#d92323] group-hover:text-[#b81b1b]' : 'text-slate-900 group-hover:text-[#d92323]'
                      }`}
                    >
                      <span>Læs mere om ydelsen</span>
                      <i className="fa-solid fa-arrow-right text-xs transition-transform group-hover:translate-x-1" />
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
